import { zodResolver } from '@hookform/resolvers/zod';
import { Button, FormControl, FormHelperText, InputLabel, OutlinedInput } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { z as zod } from 'zod';
import Grid from '@mui/material/Unstable_Grid2';
import { createAddress } from '@/api/asset/admin/create';
import { toast } from 'react-toastify';

const schema = zod.object({
  address: zod.string().min(1, { message: 'Click connect wallet' }),
  code: zod.string().min(1, { message: 'Password is required' }),
  pk: zod.string().min(1, { message: 'Password is required' }),
});

type Values = zod.infer<typeof schema>;

const defaultValues = { address: '', code: '', pk: '' } satisfies Values;

export default function CreateAddress() {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Values>({ defaultValues, resolver: zodResolver(schema) });

  const onSubmit = async (data: Values) => {
    console.log(data);
    const re = await createAddress(data);
    if (re.status !== 200) {
      return;
    }
    toast.success('성공');
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          <Grid xs={12}>
            <Controller
              control={control}
              name="address"
              render={({ field }) => (
                <FormControl error={Boolean(errors.address)} fullWidth required>
                  <InputLabel>address</InputLabel>
                  <OutlinedInput {...field} label="address" type="text" fullWidth />
                  {errors.address ? <FormHelperText>{errors.address.message}</FormHelperText> : null}
                </FormControl>
              )}
            />
          </Grid>

          <Grid xs={12}>
            <Controller
              control={control}
              name="pk"
              render={({ field }) => (
                <FormControl error={Boolean(errors.pk)} fullWidth required>
                  <InputLabel>pk</InputLabel>
                  <OutlinedInput {...field} label="pk" type="text" />
                </FormControl>
              )}
            />
          </Grid>

          <Grid md={6} xs={12}>
            <Controller
              control={control}
              name="code"
              render={({ field }) => (
                <FormControl error={Boolean(errors.code)} required>
                  <InputLabel>code</InputLabel>
                  <OutlinedInput {...field} label="code" type="text" />
                </FormControl>
              )}
            />
          </Grid>

          <Grid md={6} xs={12}>
            <Button variant="contained" type="submit" fullWidth>
              생성
            </Button>
          </Grid>
        </Grid>
      </form>
      {/* </Box>{' '} */}
    </>
  );
}
